import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector, destroy } from 'redux-form';

import { CSSTransitionGroup } from 'react-transition-group';

import { AccentColor } from 'helpers/AccentColorHelper';

import FooterButtons from 'components/shared/FooterButtons';
import { MaintenanceTemplateStatus as TemplateStatus } from 'components/shared/StatusHelper';

import { getProperties } from 'actions/landlordPropertiesActions';

import ItemsForm from './ItemsForm';
import RoomsForm from './RoomsForm';
import DetailsForm from './DetailsForm';

const TEMPLATE_FORM_NAME = 'inspection_template_form';

const style = {
  transaction_card: {
    color: '#424242 !important',
    fontFamily: '"Questrial", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    marginBottom: '15px',
  },
  header: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    margin: '8px 0px',
  },
  footer: {
    flex: '0 0 auto',
    margin: '8px 4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
};

class TemplateDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'details',
      confirmationDialogOpen: false,
    };

    this.props.getProperties({ for_multiselect: true });
  }

  componentWillUnmount() {
    this.props.destroy(TEMPLATE_FORM_NAME);
  }

  setActiveTab = (activeTab) => {
    this.setState({ activeTab });
  };

  createOrUpdateTemplate = async (formData) => {
    const res = await this.props.createOrUpdateTemplate(formData);
    if (res.value) {
      this.props.toggleDrawer();
    }
  };

  render() {
    return (
      <React.Fragment>
        <div
          className="row"
          style={{
            width: '100%',
            height: '65px',
            padding: '10px',
            textAlign: 'center',
            backgroundColor: 'white',
          }}
        >
          <h2 style={style.header}>
            {this.props.data.name || 'Add Template'}
            &nbsp;
            <TemplateStatus status={this.props.data.active} style={{ fontSize: '35%' }} />
          </h2>
        </div>

        {this.renderTabHeaders()}
        {this.renderTabBodys()}

        <div style={style.footer}>
          <FooterButtons
            backName="Close"
            formName="inspection_template_form"
            backAction={this.props.toggleDrawer}
          />
        </div>
      </React.Fragment>
    );
  }

  renderTabHeaders = () => (
    <div
      className="row"
      style={{ width: '100%', height: '29px', padding: '0 10px', backgroundColor: 'white' }}
    >
      <div className="col-xs-4">
        <TabHeader
          title="Details"
          name="details"
          onClick={this.setActiveTab}
          activeTab={this.state.activeTab}
        />
      </div>

      <div className="col-xs-4">
        <TabHeader
          title="Rooms"
          name="rooms"
          onClick={this.setActiveTab}
          activeTab={this.state.activeTab}
        />
      </div>

      <div className="col-xs-4">
        <TabHeader
          title="Items"
          name="items"
          onClick={this.setActiveTab}
          activeTab={this.state.activeTab}
        />
      </div>
    </div>
  );

  renderTabBodys = () => (
    <div
      style={{
        padding: '15px',
        height: 'calc(100% - 155px)',
        overflowY: 'scroll',
        backgroundColor: '#fbfbfb',
      }}
    >
      <CSSTransitionGroup
        transitionName="fade_out_buttons"
        transitionEnterTimeout={200}
        transitionLeaveTimeout={300}
      >
        {this._renderDetailsForm({ name: 'details' })}
        {this._renderRoomsForm({ name: 'rooms' })}
        {this._renderItemsForm({ name: 'items' })}
      </CSSTransitionGroup>
    </div>
  );

  _renderDetailsForm = ({ name }) => {
    if (this.state.activeTab !== name) return;

    return (
      <div className="row">
        <h3 style={{ margin: '0 0 15px' }}>Details</h3>
        <DetailsForm
          form={TEMPLATE_FORM_NAME}
          onSubmit={this.createOrUpdateTemplate}
          initialValues={this.props.data}
          properties={this.props.properties}
          inspectionType={this.props.inspectionType}
          selfGuided={this.props.selfGuided}
        />
      </div>
    );
  };

  _renderRoomsForm = ({ name }) => {
    if (this.state.activeTab !== name) return;

    return (
      <div className="row">
        <h3 style={{ margin: '0 0 15px' }}>Rooms</h3>
        <RoomsForm
          form={TEMPLATE_FORM_NAME}
          onSubmit={this.createOrUpdateTemplate}
          initialValues={this.props.data}
        />
      </div>
    );
  };

  _renderItemsForm = ({ name }) => {
    if (this.state.activeTab !== name) return;

    return (
      <React.Fragment>
        <h3 style={{ margin: '0 0 15px' }}>Items</h3>
        <ItemsForm
          form={TEMPLATE_FORM_NAME}
          onSubmit={this.createOrUpdateTemplate}
          initialValues={this.props.data}
        />
      </React.Fragment>
    );
  };
}

export default connect(
  (store) => ({
    properties: store.landlordProperties.properties,
    floorPlans: store.landlordProperties.floorPlans,
    inspectionType: formValueSelector(TEMPLATE_FORM_NAME)(store, 'inspection_type'),
    selfGuided: formValueSelector(TEMPLATE_FORM_NAME)(store, 'self_guided'),
  }),
  { getProperties, destroy }
)(TemplateDrawer);

const TabHeader = ({ name, title, activeTab, onClick }) => (
  <div style={{ textAlign: 'center' }}>
    <button
      type="button"
      className="link-button"
      onClick={() => onClick(name)}
      style={{
        color: AccentColor(),
        fontFamily: 'Circular-Bold',
        borderBottom: activeTab === name ? '2px solid' : 'none',
      }}
    >
      {title}
    </button>
  </div>
);
